<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row align-items-sm-center">
        <div class="col-md-9">
          <strong class="card-title mb-3">{{ 'User Profiling' }}</strong>
        </div>
        <div class="col-md-2 d-flex justify-content-end">
          <!-- <button @click="downloadXlsFile" type="button" class="btn btn-primary">Download</button> -->
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body user-profiling pt-2">
      <div class="col-md-12 d-flex justify-content-end">
        <button @click="downloadXlsFile" type="button" class="btn btn-sm btn-primary">Download</button>
      </div>
      <vue-tabs direction="horizontal" @tab-change="getTabData" active-text-color="black">
        <v-tab title="Strategy">
          <div class="card txt-fmt">
            <div class="card-body pt-0">
              <label></label>
              <form class="form-horizontal form-cs" @onsubmit.prevent action>
                <div>
                  <div class="d-flex justify-content-start mt-3">

                    <div class="col-md-6">
                      <div class="form-group d-flex align-items-center flex-wrap">
                        Strategy Title:<v-select :options="strategyMasterData" :placeholder="'Strategy Title'"
                          label="strategy_title" v-model="selectedStrategyTitleItem"
                          :reduce="option => option.strategy_title" @input="updateStrategyTitleKeyValue($event)">
                        </v-select>
                      </div>
                    </div>
                  </div>

                  <hr style="height:2px;border-width:0;color:gray;background-color:gray;margin-top:0;" />
                  <div v-if="retirementFormData.length > 0" v-for="(row, index) in retirementFormData[0].data"
                    v-bind:key="'row' + index" class="d-flex justify-content-start">
                    <div class="col-md-6 pr-2 pl-0">
                      <div class="form-group text-end d-flex align-items-center">
                        <input type="text" class="form-control txt-fmt ml-1" v-model="row.title" readonly disabled />
                      </div>
                    </div>
                    <div class="col-md-6 pr-2 pl-0">
                      <div class="form-group text-end d-flex align-items-center">
                        Answer:<input type="text" class="form-control txt-fmt ml-1" v-model="row.answer" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group d-flex justify-content-start pl-3">
                    <button type="button" class="btn btn-info" @click="submitStrategyFormData">Submit</button>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </v-tab>
        <v-tab title="Conversations Form">

          <div class="card txt-fmt" id="conversationForm">
            <form class="form-horizontal form-cs" @onsubmit.prevent action>
              <div>
                <div class="d-flex justify-content-start mt-3">

                  <div class="col-md-6">
                    <div class="form-group d-flex align-items-center flex-wrap">
                      Strategy Title:<v-select :options="strategyMasterData" :placeholder="'Strategy Title'"
                        label="strategy_title" v-model="selectedStrategyTitleItem"
                        :reduce="option => option.strategy_title" @input="updateStrategyTitleKeyValue($event)">
                      </v-select>
                    </div>
                  </div>
                  <!-- <div class="col-md-6">
                    <div class="form-group d-flex align-items-center flex-wrap mt-4">
                      <h5 class="text-bold">Target Rate Of Return: </h5><span class="ml-1 text-bold"
                        style="color: #0069da;">{{ usersStrategyForm.target_rate_of_return ? usersStrategyForm.target_rate_of_return : "-" }}</span>
                    </div>
                  </div> -->
                </div>
                <hr style="height:2px;border-width:0;color:gray;background-color:gray;margin-top:0;" />
                <table class="table table-bordered fonts11 app-inner">
                  <tr v-for="(tab, index) in usersStrategyForm.data" v-bind:key="'tab' + index">
                    <th v-if="tab.strategy_category" style="background-color: white;"><a class="d-inline btn btn-sm"
                        @click="showDetails(index)"><b>{{
                          tab.strategy_category }}</b><br><span v-if="tab.strategy_category === 'Risk Need'"
                          class="pl-2 small">(% share of portfolio in
                          growth assets
                          defines Risk Need)</span>
                        <span v-else-if="tab.strategy_category === 'Behavioral loss tolerance:'"
                          class="pl-2 small">(Low:6-13; Mod: 14-22; High:23-30)</span></a>
                      <div v-show="tab.show" class="pt-3">
                        <form class="form-horizontal form-cs" @onsubmit.prevent action>
                          <div v-if="tab.data">
                            <div>

                              <div class="col-md-12 pr-2 pl-0 d-flex justify-content-start">
                                <div class="col-md-8 d-flex">
                                  <div class="form-group text-end d-flex align-items-center flex-wrap">
                                    Target Rate of Return (Calculated) :
                                  </div>
                                </div>
                                <div class="pl-0 col-md-4">
                                  <div class="form-group text-end d-flex align-items-center flex-wrap">
                                    <input type="text" class="form-control txt-fmt" :value="usersStrategyForm.target_rate_of_return ? usersStrategyForm.target_rate_of_return : '-'" readonly disabled />
                                  </div>
                                </div>
                              </div>
                              <!-- <div class="col-md-4 pl-0">
                                <div class="form-group d-flex align-items-center flex-wrap">
                                  Type:<input
                                    v-if="row.type.question_type ? row.type.question_type == 'input' || row.type.question_type == 'risk_ability_calculation' : row.type == 'input' || row.type == 'risk_ability_calculation'"
                                    type="text" class="form-control txt-fmt" v-model="row.answer"
                                    :readonly="row.type.question_type == 'risk_ability_calculation'" />
                                  <v-select v-else
                                    :options="row.type.question_type ? row.type.response_list : row.response_list"
                                    :placeholder="'Type'"
                                    :label="row.type.question_type ? 'response_title' : 'question_type'"
                                    v-model="row.answer" @input="answerFun($event, index, cIdx)">
                                  </v-select>
                                </div>
                              </div> -->
                              <div class="col-md-12 pr-2 pl-0 d-flex justify-content-start"
                                v-for="(row, cIdx) in tab.data">
                                <div
                                  v-bind:class="row.type.question_type == 'risk_ability_calculation' || row.type == 'risk_ability_calculation' ? 'col-md-3' : 'col-md-8'">
                                  <div class="form-group text-end d-flex align-items-center flex-wrap">
                                    Title:<textarea v-model="row.title" rows="3" placeholder=""
                                      class="form-control txt-fmt txt-area" disabled readonly></textarea>
                                    <!--  <input type="text" class="form-control txt-fmt" v-model="row.title" readonly
                                      disabled /> -->
                                  </div>
                                </div>
                                <div
                                  v-if="row.type.question_type == 'risk_ability_calculation' || row.type == 'risk_ability_calculation'"
                                  class="col-md-3 pl-0">
                                  <div class="form-group text-end d-flex align-items-center flex-wrap">
                                    &nbsp;
                                    <textarea
                                      :value="cIdx === 0 ? 'The expected and/or ongoing annual liquidity need is equal to or greater than 5% of the portfolio value and no outside income or assets are available to maintain standard of living (e.g., current income, access to credit, cash savings, insurance) in case of an emergency.' : 'Investor has no significant liquidity needs (> 5% of portfolio value) for at least 10 years. Sufficient outside income and/or assets are available to maintain standard of living (e.g., current income, access to credit, cash savings, insurance) in case of an emergency.'"
                                      rows="5" placeholder="" class="form-control txt-fmt txt-area" disabled
                                      readonly></textarea>
                                  </div>
                                </div>
                                <div
                                  v-if="row.type.question_type == 'risk_ability_calculation' || row.type == 'risk_ability_calculation'"
                                  class="col-md-3 pl-0">
                                  <div class="form-group text-end d-flex align-items-center flex-wrap"
                                    v-for="(benchmarkObj, strIdx) in row.strategy_benchmark">
                                    {{ strIdx == 0 ? 'Benchmark Question:' : '' }}<textarea
                                      :value="benchmarkTabShow(benchmarkObj, strIdx)" rows="4" placeholder=""
                                      class="form-control txt-fmt txt-area" disabled readonly></textarea>
                                  </div>
                                </div>
                                <div
                                  v-if="row.type.question_type == 'risk_ability_calculation' || row.type == 'risk_ability_calculation'"
                                  class="col-md-1 pl-0">
                                  <div class="form-group text-end d-flex align-items-center flex-wrap"
                                    v-for="(benchmarkObj, strIdx) in row.strategy_benchmark">
                                    {{ strIdx == 0 ? 'Yes/No:' : '' }}<textarea
                                      :value="benchmarkObj.calculation_response" rows="4" placeholder=""
                                      class="form-control txt-fmt txt-area" disabled readonly></textarea>
                                  </div>
                                </div>
                                <div
                                  v-bind:class="row.type.question_type == 'risk_ability_calculation' || row.type == 'risk_ability_calculation' ? 'col-md-2 pl-0' : 'col-md-4 pl-0'">
                                  <div class="form-group d-flex align-items-center flex-wrap">
                                    {{ row.type.question_type }}
                                    Type:<input
                                      v-if="row.type.question_type ? row.type.question_type == 'input' || row.type.question_type == 'risk_ability_calculation' : row.type == 'input' || row.type == 'risk_ability_calculation'"
                                      type="text" class="form-control txt-fmt" v-model="row.answer"
                                      :readonly="row.type.question_type == 'risk_ability_calculation'" />
                                    <v-select v-else
                                      :options="row.type.question_type ? row.type.response_list : row.response_list"
                                      :placeholder="'Type'"
                                      :label="row.type.question_type ? 'response_title' : 'question_type'"
                                      v-model="row.answer" @input="answerFun($event, index, cIdx)">
                                    </v-select>
                                  </div>
                                </div>
                              </div>
                              <div v-if="tab.strategy_category === 'Risk-taking ability:'"
                                class="col-md-12 pr-2 pl-0 d-flex justify-content-start">
                                <div class="col-md-6">
                                  <div class="form-group text-end d-flex align-items-center flex-wrap">
                                    Title:<textarea :value="'Otherwise, the investor’s ability is MODERATE.'" rows="1"
                                      placeholder="" class="form-control txt-fmt txt-area" disabled readonly></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="tab.data[0].type.question_type !== 'risk_ability_calculation' && tab.data[0].type !== 'risk_ability_calculation'"
                              class="form-group d-flex justify-content-start pl-3">
                              <button type="button" class="btn btn-info"
                                @click="submitConversationsFormData(tab, index)">Submit</button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </th>
                  </tr>
                  <tr v-if="usersStrategyForm.data" v-bind:key="'tabnew01'">
                    <th style="background-color: white;"><a class="btn btn-sm"
                        @click="otherTabsShow('summary')"><b>Summary</b></a>
                      <div class="pt-3" v-show="otherTabs.summary">
                        <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                          <table style="width:100%;background-color:white;">
                            <tr>
                              <th>Summary:</th>
                              <th>Output</th>
                            </tr>
                            <tr>
                              <td>Risk need</td>
                              <td>{{ usersStrategyForm.risk_need }}</td>
                            </tr>
                            <tr>
                              <td>Risk-taking ability</td>
                              <td>{{ usersStrategyForm.risk_taking_ability }}</td>
                            </tr>
                            <tr>
                              <td>Behavioral loss tolerance</td>
                              <td>{{ usersStrategyForm.behavioral_loss_tolerance }}</td>
                            </tr>
                          </table>
                        </form>
                      </div>
                    </th>
                  </tr>
                  <!-- Your First Investment: START -->
                  <tr v-if="usersStrategyForm.data" v-bind:key="'tabnew02'">
                    <th style="background-color: white;"><a class="btn btn-sm"><b>Your First Investment</b></a>
                      <div class="pt-3" v-show="true">
                        <form class="form-horizontal form-cs-n form-z" @onsubmit.prevent action>
                          <div v-if="firstInvestmentTblData.length > 0" class="table-responsive scrollbar app pb-5"
                            v-dragscroll="true">
                            <table class="table table-bordered fonts11 app-inner">
                              <thead>
                                <tr>
                                  <th class="align-middle" v-for="(item, index) in firstInvestmentLblData" :key="index"
                                    :style="[item.field !== 'financial_instrument_type' && item.field !== 'product_knowledge' ? { 'width': '15%' } : { 'width': 'auto' }]">
                                    {{ item.lbl }}</th>

                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(key, index) in firstInvestmentTblData[0].data" :key="index">
                                  <td v-for="(itemLbl, subIdx) in firstInvestmentLblData" :key="subIdx">
                                    <input v-if="itemLbl.field == 'financial_instrument_type'" class="new-tbl-cs"
                                      type="text" v-model="key[itemLbl.field]" disabled />
                                    <v-select v-else-if="itemLbl.field == 'product_knowledge'" :options="['Yes', 'No']"
                                      :placeholder="'Product Knowledge'" v-model="key[itemLbl.field]"
                                      style="margin-left:0;">
                                    </v-select>
                                    <datepicker v-else-if="itemLbl.field == 'date_of_first_investment'"
                                      :input-class="'form-control date-pik'" :format="formatDate"
                                      v-model="key[itemLbl.field]" @selected="selectDate($event, index, itemLbl.field)"
                                      placeholder="Select Date" />
                                    <input v-else class="new-tbl-cs text-right" type="number"
                                      v-model="key[itemLbl.field]" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="form-group d-flex justify-content-between">
                            <button type="button" class="btn btn-info" @click="submitFirstInvestmentAPI">Submit</button>
                          </div>
                        </form>
                      </div>
                    </th>
                  </tr>
                  <!-- Your First Investment: END -->

                  <!-- Interpretation of Results:START -->
                  <tr v-if="usersStrategyForm.data" v-bind:key="'tabnew03'">
                    <th style="background-color: white;"><a class="btn btn-sm"><b>Interpretation of Results</b></a>
                      <div class="pt-3" v-show="true">
                        <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                          <table style="width:100%;background-color:white;">
                            <tr>
                              <th>Score</th>
                              <th>Risk Tolerance</th>
                              <th>Client Classification</th>
                              <th>Type of Product</th>
                              <th>Description</th>
                            </tr>
                            <tr>
                              <td>{{ interpretationResults['score '] }}</td>
                              <td>{{ interpretationResults.risk_tolerance }}</td>
                              <td>{{ interpretationResults.client_classification }}</td>
                              <td>{{ interpretationResults.type_of_product }}</td>
                              <td><textarea v-model="interpretationResults.descriptions" rows="4"
                                  class="form-control txt-fmt txt-area" style="background-color: transparent;"
                                  disabled></textarea></td>
                            </tr>
                          </table>
                        </form>
                      </div>
                    </th>
                  </tr>
                  <!-- Interpretation of Results:END -->
                  <tr v-if="usersStrategyForm.data" v-bind:key="'tabnew04'">
                    <th style="background-color: white;"><a class="btn btn-sm"
                        @click="otherTabsShow('hubble')"><b>HUBBLE–GRABLE THREE-FACTOR MODEL OF INVESTOR RISK PROFILING
                        </b></a>
                      <div class="pt-3" v-show="otherTabs.hubble">
                        <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                          <table style="width:100%;background-color:white;">
                            <tr>
                              <th>Risk Need:</th>
                              <th>Risk-Taking Ability</th>
                              <th>Behavioral Loss Tolerance</th>
                              <th>Green/Yellow/Red Light</th>
                              <th>Recommendation</th>
                            </tr>
                            <tr>
                              <td>{{ grableTreeFactorData.risk_need }}</td>
                              <td>{{ grableTreeFactorData.risk_taking_ability }}</td>
                              <td>{{ grableTreeFactorData.behavioral_loss_tolerance }}</td>
                              <td>{{ grableTreeFactorData.green_yellow_red_light }}</td>
                              <td><textarea v-model="grableTreeFactorData.recommendation" rows="3"
                                  class="form-control txt-fmt txt-area" style="background-color: transparent;"
                                  disabled></textarea></td>
                            </tr>
                          </table>
                        </form>
                      </div>
                    </th>
                  </tr>
                  <!-- Assumptions & Asset Allocation (AAA) Framework: START -->
                  <tr v-if="usersStrategyForm.data" v-bind:key="'tabnew05'">
                    <th style="background-color: white;"><a class="btn btn-sm"
                        @click="otherTabsShow('aaa')"><b>Assumptions & Asset Allocation (AAA) Framework</b></a>
                      <div class="pt-3" v-show="otherTabs.aaa">
                        <div v-if="aaaFrameworkTblData.length > 0" class="table-responsive scrollbar app"
                          v-dragscroll="true">
                          <table class="table table-bordered fonts11 app-inner">
                            <thead>
                              <tr>
                                <th class="align-middle" v-for="(item, index) in aaaFrameworkLblData" :key="index"
                                  :style="[item.field === 'input_value' ? { 'width': '12%' } : item.field === 'sub_category' ? { 'width': '40%' } : item.field === 'S_No' ? { 'width': '10%' } : { 'width': 'auto' }]">
                                  {{ item.lbl }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(key, index) in aaaFrameworkTblData[0].data" :key="index">
                                <td v-for="(itemLbl, subIdx) in aaaFrameworkLblData" :key="subIdx">
                                  <div v-if="itemLbl.field == 'input_value' || itemLbl.field == 'sub_category'"
                                    class="">
                                    <div v-for="(subCatItem, cIdx) in key.data" class="d-flex">
                                      <input class="new-tbl-aaa-cs"
                                        :class="[itemLbl.field === 'input_value' ? 'text-right' : 'text-left']"
                                        :key="cIdx" v-model="subCatItem[itemLbl.field]"
                                        :disabled="itemLbl.field == 'sub_category'" />
                                    </div>
                                  </div>
                                  <label v-else>{{ key[itemLbl.field] }}</label>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="form-group d-flex justify-content-between">
                          <button type="button" class="btn btn-info" @click="submitAAAFrameworkAPI">Submit</button>
                        </div>
                      </div>
                    </th>
                  </tr>
                  <!-- Assumptions & Asset Allocation (AAA) Framework: END -->

                  <!-- AAA (Based on Time Horizon of Goal): START -->
                  <tr v-if="usersStrategyForm.data" v-bind:key="'tabnew06'">
                    <th style="background-color: white;"><a class="btn btn-sm"
                        @click="otherTabsShow('time_horizon')"><b>Asset Allocation Assumptions (Based on Time Horizon of
                          Goal)</b></a>
                      <div class="pt-3" v-show="otherTabs.time_horizon">
                        <div v-if="aaaTimeHorizonTblData.length > 0" class="table-responsive scrollbar app"
                          v-dragscroll="true">
                          <table class="table table-bordered fonts11 app-inner">
                            <thead>
                              <tr>
                                <th class="align-middle" v-for="(item, index) in aaaTimeHorizonLblData" :key="index"
                                  :style="[item.field === 'input_value' ? { 'width': '12%' } : item.field === 'sub_category' ? { 'width': '40%' } : item.field === 'S_No' ? { 'width': '10%' } : { 'width': 'auto' }]">
                                  {{ item.lbl }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(key, index) in aaaTimeHorizonTblData[0].data" :key="index">
                                <td v-for="(itemLbl, subIdx) in aaaTimeHorizonLblData" :key="subIdx"
                                  class="time-horizon-cs"
                                  :class="[itemLbl.field === 'Total' || itemLbl.field === 'Portfolio_Returns' ? 'text-right align-middle' : 'align-middle']">
                                  <input type="number"
                                    v-if="itemLbl.field == 'Liquid' || itemLbl.field == 'Debt' || itemLbl.field == 'Gold' || itemLbl.field == 'Equity'"
                                    class="new-tbl-aaa-cs text-right" :key="subIdx" v-model="key[itemLbl.field]" />
                                  <label v-else>{{
                                    key[itemLbl.field] }}</label>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="form-group d-flex justify-content-between">
                          <button type="button" class="btn btn-info" @click="submitAAATimeHorizonAPI">Submit</button>
                        </div>
                      </div>
                    </th>
                  </tr>
                  <!-- AAA (Based on Time Horizon of Goal): END -->

                  <!-- AAA (Based on Risk Profile of Client): START -->
                  <tr v-if="usersStrategyForm.data" v-bind:key="'tabnew07'">
                    <th style="background-color: white;"><a class="btn btn-sm"
                        @click="otherTabsShow('risk_profile')"><b>Asset Allocation Assumptions (Based on Risk Profile of
                          Client)</b></a>
                      <div class="pt-3" v-show="otherTabs.risk_profile">
                        <div v-if="aaaRiskProfileOfClientTblData.length > 0" class="table-responsive scrollbar app"
                          v-dragscroll="true">
                          <table class="table table-bordered fonts11 app-inner">
                            <thead>
                              <tr>
                                <th class="align-middle" v-for="(item, index) in aaaRiskProfileOfClientLblData"
                                  :key="index"
                                  :style="[item.field === 'Type_of_Investor' ? { 'width': '20%' } : item.field === 'Risk_Profile' ? { 'width': '15%' } : item.field === 'S_No' ? { 'width': '8%' } : { 'width': 'auto' }]">
                                  {{ item.lbl }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(key, index) in aaaRiskProfileOfClientTblData[0].data" :key="index">
                                <td v-for="(itemLbl, subIdx) in aaaRiskProfileOfClientLblData" :key="subIdx"
                                  class="time-horizon-cs"
                                  :class="[itemLbl.field === 'Total' || itemLbl.field === 'Portfolio_Returns' ? 'text-right align-middle' : 'align-middle']">
                                  <input type="number"
                                    v-if="itemLbl.field == 'Liquid' || itemLbl.field == 'Debt' || itemLbl.field == 'Gold' || itemLbl.field == 'Equity'"
                                    class="new-tbl-aaa-cs text-right" :key="subIdx" v-model="key[itemLbl.field]" />
                                  <label v-else>{{ key[itemLbl.field] }}</label>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="form-group d-flex justify-content-between">
                          <button type="button" class="btn btn-info"
                            @click="submitAAARiskProfileOfClientAPI">Submit</button>
                        </div>
                      </div>
                    </th>
                  </tr>
                  <!-- AAA (Based on Risk Profile of Client): END -->

                  <!-- AAA (Income Generation Requirement): START -->
                  <tr v-if="usersStrategyForm.data" v-bind:key="'tabnew08'">
                    <th style="background-color: white;"><a class="btn btn-sm"
                        @click="otherTabsShow('income_generation')"><b>Asset Allocation Assumptions (Income Generation
                          Requirement)</b></a>
                      <div class="pt-3" v-show="otherTabs.income_generation">
                        <div v-if="aaaIncomeGenerationTblData.length > 0" class="table-responsive scrollbar app"
                          v-dragscroll="true">
                          <table class="table table-bordered fonts11 app-inner">
                            <thead>
                              <tr>
                                <th class="align-middle" v-for="(item, index) in aaaIncomeGenerationLblData"
                                  :key="index"
                                  :style="[item.field === 'When' ? { 'width': '20%' } : item.field === 'Type_of_Corpus' ? { 'width': '15%' } : item.field === 'S_No' ? { 'width': '8%' } : { 'width': 'auto' }]">
                                  {{ item.lbl }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(key, index) in aaaIncomeGenerationTblData[0].data" :key="index">
                                <td v-for="(itemLbl, subIdx) in aaaIncomeGenerationLblData" :key="subIdx"
                                  class="time-horizon-cs"
                                  :class="[itemLbl.field === 'Total' || itemLbl.field === 'Portfolio_Returns' ? 'text-right align-middle' : 'align-middle']">
                                  <input type="number"
                                    v-if="itemLbl.field == 'Liquid' || itemLbl.field == 'Debt' || itemLbl.field == 'Gold' || itemLbl.field == 'Equity'"
                                    class="new-tbl-aaa-cs text-right" :key="subIdx" v-model="key[itemLbl.field]" />
                                  <label v-else>{{ key[itemLbl.field] }}</label>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="form-group d-flex justify-content-between">
                          <button type="button" class="btn btn-info"
                            @click="submitAAAIncomeGenerationAPI">Submit</button>
                        </div>
                      </div>
                    </th>
                  </tr>
                  <!-- AAA (Income Generation Requirement): END -->

                  <!-- Professionals Recommendation to Client: START -->
                  <tr v-if="usersStrategyForm.data" v-bind:key="'tabnew09'">
                    <th style="background-color: white;"><a class="btn btn-sm"
                        @click="otherTabsShow('professionals_recommendation')"><b>Professional's Recommendation to
                          Client</b></a>
                      <div class="pt-3" v-show="otherTabs.professionals_recommendation">
                        <div v-if="aaaRecommendationToClientTblData.length > 0" class="table-responsive scrollbar app"
                          v-dragscroll="true">
                          <table class="table table-bordered fonts11 app-inner">
                            <thead>
                              <tr>
                                <th class="align-middle" v-for="(item, index) in aaaRecommendationToClientLblData"
                                  :key="index"
                                  :style="[item.field === 'Investment_Portfolio_Name' ? { 'width': '35%' } : item.field === 'S_No' ? { 'width': '8%' } : { 'width': 'auto' }]">
                                  {{ item.lbl }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(key, index) in aaaRecommendationToClientTblData[0].data" :key="index">
                                <td v-for="(itemLbl, subIdx) in aaaRecommendationToClientLblData" :key="subIdx"
                                  class="time-horizon-cs"
                                  :class="[itemLbl.field === 'Total' || itemLbl.field === 'Portfolio_Returns' ? 'text-right align-middle' : 'align-middle']">
                                  <input type="number"
                                    v-if="itemLbl.field == 'Liquid' || itemLbl.field == 'Debt' || itemLbl.field == 'Gold' || itemLbl.field == 'Equity'"
                                    class="new-tbl-aaa-cs text-right" :key="subIdx" v-model="key[itemLbl.field]" />
                                  <label v-else>{{ key[itemLbl.field] }}</label>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="form-group d-flex justify-content-between">
                          <button type="button" class="btn btn-info"
                            @click="submitRecommendationToClientAPI">Submit</button>
                        </div>
                      </div>
                    </th>
                  </tr>
                  <!-- Professionals Recommendation to Client: END -->

                </table>
              </div>
            </form>
          </div>
        </v-tab>
      </vue-tabs>

      <div class="clear-fix"></div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import Datepicker from "vuejs-datepicker";
import { commonMixins } from "../../assets/mixins/common.js";
export default {
  components: { Datepicker },
  mixins: [commonMixins],
  name: "UserProfiling",
  props: ["user"],
  created() {
    console.log('user-profiling >> this.$route.params', this.$route.params)
    this.userId = parseFloat(this.$route.params.id);
    this.selectedStrategyTitleItem = null;
    this.getStrategyMasterData();
    /* if (!this.$route.params.id) {
      this.$router.push({ name: "user-listing" });
    }
    console.log("Config ", process.env.API_URL);
    this.url = this.apiUrl;
    this.userId = this.$route.params.id;
    console.log(
      this.url.indexOf("user-portfolio"),
      this.$route.params,
      this.$route.query
    );
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = "");
    this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    this.fetchData(this.searchParams); */
  },
  /* watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  }, */
  data() {
    return {
      cutTab: "Strategy",
      userId: null,
      apiUrl: "frontend/getStockUserDetails",
      retirementFormData: [{ "data": [] }],
      strategyMasterData: [],
      selectedStrategyTitleItem: null,
      selectedCategoryItem: null,
      ifIsBlank: false,
      categoryMasterData: [],
      usersStrategyForm: [],
      otherTabs: { summary: true, hubble: true, aaa: true, time_horizon: true, risk_profile: true, income_generation: true, professionals_recommendation: true },
      grableTreeFactorData: {},
      interpretationResults: {},
      firstInvestmentTblData: [],
      firstInvestmentLblData: [{ lbl: "Financial instrument type", field: "financial_instrument_type" },
      { lbl: "Product knowledge", field: "product_knowledge" },
      { lbl: "Date of first investment", field: "date_of_first_investment" },
      { lbl: "Invested amount (INR)", field: "invested_amount_INR_cr" },
      { lbl: "Number of transactions", field: "mumber_of_transactions" }],
      aaaFrameworkLblData: [
        { lbl: "S No.", field: "S_No" },
        {
          lbl: "Assumption", field: "Assumption", child: [{ lbl: "Sub-Category", field: "sub_category" },
          { lbl: "Figure", field: "input_value" }]
        },
        { lbl: "Sub-Category", field: "sub_category" },
        { lbl: "Figure", field: "input_value" }],
      aaaFrameworkTblData: [],
      aaaTimeHorizonLblData: [
        { lbl: "S No.", field: "S_No" },
        { lbl: "Category", field: "Category" },
        { lbl: "Description", field: "Description" },
        { lbl: "Liquid", field: "Liquid" },
        { lbl: "Debt", field: "Debt" },
        { lbl: "Gold", field: "Gold" },
        { lbl: "Equity", field: "Equity" },
        { lbl: "Total", field: "Total" },
        { lbl: "Portfolio Returns", field: "Portfolio_Returns" }
      ],
      aaaTimeHorizonTblData: [],
      aaaRiskProfileOfClientLblData: [
        { lbl: "S No.", field: "S_No" },
        { lbl: "Type of Investor", field: "Type_of_Investor" },
        { lbl: "Risk Profile", field: "Risk_Profile" },
        { lbl: "Liquid", field: "Liquid" },
        { lbl: "Debt", field: "Debt" },
        { lbl: "Gold", field: "Gold" },
        { lbl: "Equity", field: "Equity" },
        { lbl: "Total", field: "Total" },
        { lbl: "Portfolio Returns", field: "Portfolio_Returns" }
      ],
      aaaRiskProfileOfClientTblData: [],
      aaaIncomeGenerationLblData: [
        { lbl: "S No.", field: "S_No" },
        { lbl: "Type of Corpus", field: "Type_of_Corpus" },
        { lbl: "When", field: "When" },
        { lbl: "Liquid", field: "Liquid" },
        { lbl: "Debt", field: "Debt" },
        { lbl: "Gold", field: "Gold" },
        { lbl: "Equity", field: "Equity" },
        { lbl: "Total", field: "Total" },
        { lbl: "Portfolio Returns", field: "Portfolio_Returns" }
      ],
      aaaIncomeGenerationTblData: [],
      aaaRecommendationToClientLblData: [
        { lbl: "S No.", field: "S_No" },
        { lbl: "Investment Portfolio Name", field: "Investment_Portfolio_Name" },
        { lbl: "Liquid", field: "Liquid" },
        { lbl: "Debt", field: "Debt" },
        { lbl: "Gold", field: "Gold" },
        { lbl: "Equity", field: "Equity" },
        { lbl: "Total", field: "Total" },
        { lbl: "Portfolio Returns", field: "Portfolio_Returns" }
      ],
      aaaRecommendationToClientTblData: [],
    };
  },
  methods: {
    reset() {

    },
    downloadXlsFile() {
      let self = this;

      console.log('self.selectedStrategyTitleItem: ', self.selectedStrategyTitleItem);
      if (self.selectedStrategyTitleItem == null) {
        self.$toastr.error("Please Select `Strategy Title`", "", {});
        return;
      }

      let paramData = { "client_id": self.userId, "strategy_title": self.selectedStrategyTitleItem != null ? self.selectedStrategyTitleItem.strategy_title : "" };
      console.log('paramData: ', paramData);
      //return;
      http.post("/frontend/download_sheet_user_profile/get", paramData, (error, response) => {
        if (response.responseType === 'success') {
          console.log('res data', response);
          window.open(response.download_link);
        }
      });

    },
    benchmarkTabShow(obj, idx) {
      //const desc = '•' + obj.user_field + ' - ' + obj.answer + '\n•' + obj.title + ' - ' + obj.calculation_response;
      //Time horizon is less than or equal to five years.
      const desc = obj.user_field + ' ' + obj.calculation_formula + ' ' + obj.answer + (idx === 0 ? ' years' : ' %');
      return desc;
    },
    formatDate(date) {
      console.log('formatDate', this.getDate(date));
      return this.getDate(date);
    },
    selectDate(date, pIdx, field) {
      //console.log('selectDate', this.getDate(date));
      this.firstInvestmentTblData[0].data[pIdx].date_of_first_investment = String(this.getDate(date));
      console.log('selectDate key: ', String(field));
      //console.log('pData', pData);
      console.log('firstInvestmentTblData[0].data >>> ', this.firstInvestmentTblData[0].data[pIdx].date_of_first_investment)
      /* const strKey = String(key)
      console.log('with pData', pData[strKey]);
      pData.date_of_first_investment = this.getDate(date); */
      //return this.getDate(date);
    },
    otherTabsShow(key) {
      //this.otherTabs[key] = !this.otherTabs[key];
    },
    answerFun(evt, index, cIdx) {
      //console.log('answer:', typeof (evt));
      //console.log('answer:', evt);
      if (evt != null) {
        if (typeof (evt) == 'object') {
          //console.log(evt.value);
          //ans = evt.value;
          this.usersStrategyForm.data[index].data[cIdx].answer = evt.value ? evt.value : "";
        }
      } else {
        this.usersStrategyForm.data[index].data[cIdx].answer = "";
      }
    },
    showDetails(idx) {
      console.log('idx', idx);
      this.usersStrategyForm.data[idx].show = !this.usersStrategyForm.data[idx].show;
      console.log('this.usersStrategyForm', this.usersStrategyForm.data);
    },
    updateStrategyTitleKeyValue(event) {
      console.log('selectedStrategyTitleItem >>> ', this.selectedStrategyTitleItem);
      console.log('this.cutTab >>> ', this.cutTab);

      if (this.cutTab === 'Strategy') {
        if (this.selectedStrategyTitleItem != null) {
          this.getStrategyData();
        } else {
          this.retirementFormData = [{ "data": [] }];
        }
      } else if (this.cutTab === 'Conversations Form') {
        this.usersStrategyForm = [];
        this.getUsersStrategyFromById();
        //this.getUsersStrategyFrom();
      }

    },
    /* updateStrategyCategoryKeyValue(event) {
      console.log('selectedCategoryItem >>> ', this.selectedCategoryItem, 'selectedStrategyTitleItem >>> ', this.selectedStrategyTitleItem)
    }, */
    getStrategyMasterData() {
      let self = this;
      http.get("/frontend/strategy/get", {}, (error, response) => {
        if (response.status === 'success') {
          self.strategyMasterData = response.data;
        }
      });
    },
    getStrategyData() {
      let self = this;
      if (self.selectedStrategyTitleItem == null) {
        self.$toastr.error("Please Select `Strategy Title`", "", {});
        return;
      }
      let data = {};
      if (self.ifIsBlank === false) {
        data = { "client_id": self.userId, "strategy_title": self.selectedStrategyTitleItem.strategy_title };
      }
      console.log('data', data);

      http.post("/frontend/strategy_columns/get?type=super_admin", data, (error, response) => {
        if (response.status === 'success') {
          self.retirementFormData = response.data;
          console.log('res data', response.data);
          if (response.data.length === 0) {
            self.ifIsBlank = true;
            self.retirementFormData = [{ "data": [] }];
            self.getStrategyData();
          } else {
            self.ifIsBlank = false;
          }
        }
      });
    },
    submitStrategyFormData() {
      let self = this;
      //{ "client_id": self.userId, "strategy_title": self.selectedStrategyTitleItem.strategy_title }
      console.log('submit data', this.retirementFormData[0]);
      let notValid = false;
      this.retirementFormData[0].data.map((item) => {
        //console.log('###=> ', item.title, item.type)
        if (item.title == "" || item.answer == "") {
          //console.log('Not Valid');
          notValid = true;
        }
      });
      if (notValid) {
        this.$toastr.error("Please fill the form proper !", "", {});
        return;
      }

      let dataCollection = {};
      dataCollection = { "client_id": self.userId, "strategy_title": self.selectedStrategyTitleItem.strategy_title, data: self.retirementFormData[0].data };

      console.log('dataCollection::', dataCollection);
      //return;

      http.post("/frontend/strategy_columns_user_response/update", dataCollection, function (error, response) {
        console.log(">>>> post data:", response);
        if (response.responseType === "success") {
          self.$toastr.success(response.msg, "", {});
          self.getUsersStrategyFromById();
        }
      });
    },
    getCategoryMasterData() {
      let self = this;
      http.get("/frontend/strategy_category/get?type=super_admin", {}, (error, response) => {
        if (response.status === 'success') {
          self.categoryMasterData = response.data;
        }
      });
    },
    getUsersStrategyFromById() {
      let self = this;
      let paramData = {};
      if (this.selectedStrategyTitleItem == null) {
        return;
      }
      paramData = {
        "client_id": self.userId,
        "strategy_title": this.selectedStrategyTitleItem.strategy_title
      }
      http.post("/frontend/user_strategy_form_user_response/get", paramData, function (error, response) {
        console.log(">>>> post data:", response);
        if (response.status === "success") {
          //self.$toastr.success(response.msg, "", {});
          console.log('getUsersStrategyFrom >>> ', response.data);
          if (response.data.length === 0) {
            self.getUsersStrategyFrom();
          } else {
            let collectUsersStrategyForm = [];
            response.data[0].data.map((item) => {
              let collectObj = item;
              collectObj.show = false;
              console.log('collectObj', collectObj);
              collectUsersStrategyForm.push(collectObj);
            });
            response.data[0].data = collectUsersStrategyForm;
            self.usersStrategyForm = response.data[0];
            console.log('### self.usersStrategyForm >>>', self.usersStrategyForm);

            self.getGrableTreeFactorData();
            self.getInterpretationResults();
            self.getFirstTimeInvestmentData();
            self.getAAAFrameworkAPI();
            self.getAAATimeHorizonAPI();
            self.getAAARiskProfileOfClientAPI();
            self.getAAAIncomeGenerationAPI();
            self.getRecommendationToClientAPI();

          }
        }
      });
    },
    getUsersStrategyFrom() {

      let self = this;
      if (this.selectedStrategyTitleItem == null) {
        return;
      }
      let paramData = {};
      paramData = {
        "strategy_title": this.selectedStrategyTitleItem.strategy_title
      }

      http.post("/frontend/user_strategy_form/get", paramData, function (error, response) {
        if (response.status === "success") {
          console.log('getUsersStrategyFrom >>> ', response.data);
          let collectUsersStrategyForm = [];
          response.data.map((item) => {
            let collectObj = item;
            collectObj.show = false;
            collectUsersStrategyForm.push(collectObj);
          });
          self.usersStrategyForm = { data: collectUsersStrategyForm };
          console.log('### getUsersStrategyFrom #=>', self.usersStrategyForm);

          if (self.usersStrategyForm.data.length > 0) {
            self.getGrableTreeFactorData();
            self.getInterpretationResults();
            self.getFirstTimeInvestmentData();
            self.getAAAFrameworkAPI();
            self.getAAATimeHorizonAPI();
            self.getAAARiskProfileOfClientAPI();
            self.getAAAIncomeGenerationAPI();
            self.getRecommendationToClientAPI();
          } else {
            self.usersStrategyForm = [];
            self.grableTreeFactorData = {};
            self.interpretationResults = {};
            self.firstInvestmentTblData = [];
            self.aaaFrameworkTblData = [];
            self.aaaTimeHorizonTblData = [];
            self.aaaRiskProfileOfClientTblData = [];
            self.aaaIncomeGenerationTblData = [];
            self.aaaRecommendationToClientTblData = [];
          }

          /* response.data[0].data.map((item) => {
            let collectObj = item;
            collectObj.show = false;
            console.log('collectObj', collectObj);
            collectUsersStrategyForm.push(collectObj);
          });
          response.data[0].data = collectUsersStrategyForm;
          self.usersStrategyForm = response.data[0]; */

        }
      });
    },
    getGrableTreeFactorData() {
      let self = this;
      let paramData = {};
      paramData = {
        "behavioral_loss_tolerance": self.usersStrategyForm.behavioral_loss_tolerance ? self.usersStrategyForm.behavioral_loss_tolerance : "",
        "risk_need": self.usersStrategyForm.risk_need ? self.usersStrategyForm.risk_need : "",
        "risk_taking_ability": self.usersStrategyForm.risk_taking_ability ? self.usersStrategyForm.risk_taking_ability : ""
      }
      console.log('getGrableTreeFactorData paramData', paramData);

      http.post("/frontend/grable_tree_factor_model_of_investor_risk_profile_user_reponse/get", paramData, function (error, response) {
        if (response.status === "success") {
          console.log('getUsersStrategyFrom >>> ', response.data);
          self.grableTreeFactorData = response.data.length > 0 ? response.data[0] : {};
        }
      });
    },
    getInterpretationResults() {
      let self = this;
      let paramData = {};
      paramData = {
        "client_id": self.userId,
        "strategy_title": this.selectedStrategyTitleItem.strategy_title
      }
      console.log('getInterpretationResults paramData', paramData);


      http.post("/frontend/interpretation_of_results/get", paramData, function (error, response) {
        if (response.status === "success") {
          console.log('getInterpretationResults >>> ', response.data);
          self.interpretationResults = response.data.length > 0 ? response.data[0].data : {};
        }
      });
    },
    getFirstTimeInvestmentData(flg = false) {
      //firstInvestmentTblData
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {
          "strategy_title": this.selectedStrategyTitleItem.strategy_title
        }
      } else {
        paramData = {
          "client_id": self.userId,
          "strategy_title": this.selectedStrategyTitleItem.strategy_title
        }
      }
      console.log('getFirstTimeInvestmentData paramData', paramData);


      http.post("/frontend/experience_since_your_first_investment_form/get", paramData, function (error, response) {
        if (response.status === "success") {
          console.log('getFirstTimeInvestmentData >>> ', response.data);
          if (response.data.length > 0) {
            self.firstInvestmentTblData = response.data;
          } else {
            self.getFirstTimeInvestmentData(true);
          }
        }
      });
    },
    submitFirstInvestmentAPI() {

      /* { lbl: "Product knowledge", field: "product_knowledge" },
      { lbl: "Date of first investment", field: "date_of_first_investment" },
      { lbl: "Invested amount (INR cr)", field: "invested_amount_INR_cr" },
      { lbl: "Number of transactions", field: "mumber_of_transactions" }], */

      console.log('this.firstInvestmentTblData >>>', this.firstInvestmentTblData);
      let self = this;
      const obj = this.firstInvestmentTblData;
      /* let notValid = false;
      obj[0].data.map((item) => {
        if (item.financial_instrument_type == "" || item.product_knowledge == "" || item.product_knowledge == null || item.date_of_first_investment == "" || item.invested_amount_INR_cr == "" || item.mumber_of_transactions == "") {
          notValid = true;
        }
      });
      if (notValid) {
        this.$toastr.error("Please fill the 'Financial instrument type' and 'Product knowledge' form proper !", "", {});
        return;
      } */
      let paramData = {};
      paramData = {
        "client_id": self.userId,
        "strategy_title": this.selectedStrategyTitleItem.strategy_title,
        "data": obj[0].data
      }

      console.log('submitFirstInvestmentAPI >>>', paramData);
      //return;

      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        //console.log('submitFirstInvestmentAPI >>> ', obj[0]);
        http.post("/frontend/experience_since_your_first_investment_form/update", paramData, function (error, response) {

          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            //self.getFirstInvestmentAPI();
            self.getUsersStrategyFromById();
          }
          self.isNew = false;
          self.isShow = false;
        });
      }
    },
    /* getConversationsFormData() {
      let self = this;
      if (this.selectedStrategyTitleItem == null || this.selectedCategoryItem == null) {
        self.$toastr.error("Please select Strategy Title and Category form list", "", {});
        return;
      }
      const data = { 'strategy_category': this.selectedCategoryItem.strategy_category, 'strategy_title': this.selectedStrategyTitleItem.strategy_title };

      http.post("/frontend/strategy_question/get?type=super_admin", data, (error, response) => {
        if (response.status === 'success') {

          if (response.data.length === 0) {
            self.strategyQueObject = {
              "strategy_category": this.selectedCategoryItem != null ? this.selectedCategoryItem.strategy_category : "",
              "strategy_title": this.selectedStrategyTitleItem != null ? this.selectedStrategyTitleItem.strategy_title : "",
              "data": []
            };
          } else {
            self.strategyQueObject = response.data[0];
          }
        }
      });
    }, */
    submitConversationsFormData(tab, idx) {
      /* console.log('submit ConversationsForm Data 1 ::', this.usersStrategyForm);
      console.log('submit ConversationsForm Data 2 ::', tab, idx);
      console.log('submit ConversationsForm Data 3 ::', this.usersStrategyForm.data[idx]); */

      let self = this;
      let notValid = false;
      tab.data.map((item) => {
        if (item.answer == "" || item.answer == null) {
          //console.log('Not Valid');
          notValid = true;
        }
      });
      if (tab.risk_taking_ability) {
        notValid = false;
      }
      if (notValid) {
        this.$toastr.error("Please fill all the fields of form !", "", {});
        return;
      }

      let collectUsersStrategyForm = {};
      collectUsersStrategyForm = {
        "client_id": self.userId,
        "strategy_title": this.selectedStrategyTitleItem.strategy_title,
        'data': self.usersStrategyForm.data
      }

      console.log('Submit CollectUsersStrategyForm >>>', collectUsersStrategyForm);
      //return;

      http.post("/frontend/user_strategy_form_update_user_response/update", collectUsersStrategyForm, (error, response) => {
        console.log('response >>>', response)
        if (response.responseType === 'success') {
          self.$toastr.success(response.msg, "", {});
          self.getUsersStrategyFromById();
        }
      });
    },
    /* AAA FrameworkAPI : START */
    getAAAFrameworkAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {
          "strategy_title": this.selectedStrategyTitleItem.strategy_title
        }
      } else {
        paramData = {
          "client_id": self.userId,
          "strategy_title": this.selectedStrategyTitleItem.strategy_title
        }
      }
      console.log('getAAAFrameworkAPI paramData', paramData);

      http.post("/frontend/assumptions_asset_allocation_framework/get", paramData, (error, response) => {
        if (response.status === 'success') {
          if (response.data.length > 0) {
            self.aaaFrameworkTblData = response.data;
          } else {
            self.getAAAFrameworkAPI(true);
          }
          console.log('aaaFrameworkTblData >>>', self.aaaFrameworkTblData);

        }
      });
    },
    submitAAAFrameworkAPI() {
      console.log('this.aaaFrameworkTblData >>>', this.aaaFrameworkTblData);
      let self = this;
      const obj = this.aaaFrameworkTblData;
      let notValid = false;
      obj[0].data.map((item) => {
        //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
        item.data.map((childItem) => {
          /* if (childItem.input_value == "") {
            notValid = true;
          } */
          if (item.S_No == "" || item.Assumption == "") {
            notValid = true;
          }
          item.data.map((childItem) => {
            if (childItem.sub_category == "") {
              notValid = true;
            }
          });
        });
      });


      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      let collectFormData = {};
      collectFormData = {
        "client_id": self.userId,
        "strategy_title": this.selectedStrategyTitleItem.strategy_title,
        'data': obj[0].data
      }

      console.log('collectFormData >>>', collectFormData);
      //return;

      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        console.log('submitAAAFrameworkAPI >>> ', obj[0]);
        http.post("/frontend/assumptions_asset_allocation_framework/update", collectFormData, function (error, response) {
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getAAAFrameworkAPI();
          }
          self.isNew = false;
          self.isShow = false;
        });
      }
    },
    /* AAA FrameworkAPI : END */

    /* AAA (Based on Time Horizon of Goal) : START */
    getAAATimeHorizonAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {
          "strategy_title": this.selectedStrategyTitleItem.strategy_title
        }
      } else {
        paramData = {
          "client_id": self.userId,
          "strategy_title": this.selectedStrategyTitleItem.strategy_title
        }
      }
      console.log('getAAATimeHorizonAPI paramData', paramData);

      http.post("/frontend/assest_allocation_assumptions_time_horizon_based/get", paramData, (error, response) => {
        if (response.status === 'success') {
          if (response.data.length > 0) {
            self.aaaTimeHorizonTblData = response.data;
          } else {
            self.getAAATimeHorizonAPI(true);
          }
          console.log('aaaTimeHorizonTblData >>>', self.aaaTimeHorizonTblData);
        }
      });
    },
    submitAAATimeHorizonAPI() {
      console.log('this.aaaTimeHorizonTblData >>>', this.aaaTimeHorizonTblData);
      let self = this;
      const obj = this.aaaTimeHorizonTblData;
      let notValid = false;
      obj[0].data.map((item) => {
        console.log('###=> ', item)
        if (item.Liquid == "" || item.Debt == "" || item.Gold == "" || item.Equity == "") {
          notValid = true;
        }
      });


      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      let collectFormData = {};
      collectFormData = {
        "client_id": self.userId,
        "strategy_title": this.selectedStrategyTitleItem.strategy_title,
        'data': obj[0].data
      }

      console.log('collectFormData >>>', collectFormData);
      //return;

      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        console.log('aaaTimeHorizonTblData >>> ', collectFormData);
        http.post("/frontend/assest_allocation_assumptions_time_horizon_based/update", collectFormData, function (error, response) {
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getAAATimeHorizonAPI();
          } else if (response.responseType == "Fail") {
            self.$toastr.error(response.msg, "", {});
          }
          self.isNew = false;
          self.isShow = false;
        });
      }
    },
    /* AAA (Based on Time Horizon of Goal) : END */

    /* AAA Based-on-Risk-Profile-of-Client : START */
    getAAARiskProfileOfClientAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {
          "strategy_title": this.selectedStrategyTitleItem.strategy_title
        }
      } else {
        paramData = {
          "client_id": self.userId,
          "strategy_title": this.selectedStrategyTitleItem.strategy_title
        }
      }
      console.log('getAAARiskProfileOfClientAPI paramData', paramData);

      http.post("/frontend/asset_allocation_assumption_risk_profile_client_based/get", paramData, (error, response) => {
        if (response.status === 'success') {
          if (response.data.length > 0) {
            self.aaaRiskProfileOfClientTblData = response.data;
          } else {
            self.getAAARiskProfileOfClientAPI(true);
          }
          console.log('aaaRiskProfileOfClientTblData >>>', self.aaaRiskProfileOfClientTblData);
        }
      });
    },
    submitAAARiskProfileOfClientAPI() {
      let self = this;
      const obj = this.aaaRiskProfileOfClientTblData;
      let notValid = false;
      obj[0].data.map((item) => {
        if (item.Liquid == "" || item.Debt == "" || item.Gold == "" || item.Equity == "") {
          notValid = true;
        }
      });
      console.log('notValid:', notValid);
      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        console.log('submitAAARiskProfileOfClientAPI >>> ', obj[0]);
        //return;  
        http.post("/frontend/asset_allocation_assumption_risk_profile_client_based/update", obj[0], function (error, response) {
          //console.log(">>>> post data:", response);
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getAAARiskProfileOfClientAPI();
          }
          self.isNew = false;
          self.isShow = false;
        });
      }
    },
    /* AAA Based-on-Risk-Profile-of-Client : END */

    /* AAA Income Generation Requirement : START */
    getAAAIncomeGenerationAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {
          "strategy_title": this.selectedStrategyTitleItem.strategy_title
        }
      } else {
        paramData = {
          "client_id": self.userId,
          "strategy_title": this.selectedStrategyTitleItem.strategy_title
        }
      }
      console.log('getAAAIncomeGenerationAPI paramData', paramData);

      http.post("/frontend/asset_allocation_assumptions_income_generation/get", paramData, (error, response) => {
        if (response.status === 'success') {
          if (response.data.length > 0) {
            self.aaaIncomeGenerationTblData = response.data;
          } else {
            self.getAAAIncomeGenerationAPI(true);
          }
          console.log('getAAAIncomeGenerationAPI >>>', self.aaaIncomeGenerationTblData);
        }
      });
    },
    submitAAAIncomeGenerationAPI() {
      let self = this;
      const obj = this.aaaIncomeGenerationTblData;
      let notValid = false;
      obj[0].data.map((item) => {
        if (item.Liquid == "" || item.Debt == "" || item.Gold == "" || item.Equity == "") {
          notValid = true;
        }
      });
      console.log('notValid:', notValid);
      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        console.log('submitAAARiskProfileOfClientAPI >>> ', obj[0]);
        //return;  
        http.post("/frontend/asset_allocation_assumptions_income_generation/update", obj[0], function (error, response) {
          //console.log(">>>> post data:", response);
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getAAAIncomeGenerationAPI();
          }
          self.isNew = false;
          self.isShow = false;
        });
      }
    },
    /* AAA Income Generation Requirement : END */

    /* Professional's Recommendation to Client: START */
    getRecommendationToClientAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {
          "strategy_title": this.selectedStrategyTitleItem.strategy_title
        }
      } else {
        paramData = {
          "client_id": self.userId,
          "strategy_title": this.selectedStrategyTitleItem.strategy_title
        }
      }
      console.log('getAAAIncomeGenerationAPI paramData', paramData);

      http.post("/frontend/professional_recommendation_to_client/get", paramData, (error, response) => {
        if (response.status === 'success') {
          if (response.data.length > 0) {
            self.aaaRecommendationToClientTblData = response.data;
          } else {
            self.getRecommendationToClientAPI(true);
          }
          console.log('getAAAIncomeGenerationAPI >>>', self.aaaRecommendationToClientTblData);
        }
      });
    },
    submitRecommendationToClientAPI() {
      let self = this;
      const obj = this.aaaRecommendationToClientTblData;
      let notValid = false;
      obj[0].data.map((item) => {
        //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
        if (item.Liquid == "" || item.Debt == "" || item.Gold == "" || item.Equity == "") {
          notValid = true;
        }
      });
      console.log('notValid:', notValid);
      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        console.log('submitRecommendationToClientAPI >>> ', obj[0]);
        //return;
        http.post("/frontend/professional_recommendation_to_client/update", obj[0], function (error, response) {
          //console.log(">>>> post data:", response);
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getRecommendationToClientAPI();
          }
          self.isNew = false;
          self.isShow = false;
        });
      }
    },
    /* Professional's Recommendation to Client: END */
    getTabData(tabIndex, newTab, oldTab) {
      console.log('Tab:', tabIndex, newTab.title, oldTab.title);
      this.cutTab = newTab.title;
      this.selectedStrategyTitleItem = null;
      if (newTab.title === 'Strategy') {
        this.getStrategyMasterData();
        //this.getStrategyData();
      } else if (newTab.title === 'Conversations Form') {
        this.usersStrategyForm = [];
        this.strategyMasterData = [];
        this.selectedStrategyTitleItem = null;
        this.getStrategyMasterData();
        this.getCategoryMasterData();
      }

      this.isNew = false;
      this.isShow = false;
    },

  }
};
</script>
<style>
.table {
  font-size: 0.925em;
}

/* .vdp-datepicker input{
  font-size: small !important;
  background-color: white !important;
} */

.table td {
  padding: 4px 10px 4px 10px !important;
}

.table-xirr {
  width: auto;
}

.txt-area {
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.form-cs-n {
  border: 1px solid #c4c2c2;
  padding: 13px;
  /* padding-bottom: 0; */
  border-radius: 7px;
  background-color: #f5faff;
}

.date-pik {
  background-color: white !important;
  /* height: 1.8rem; */
  font-size: x-small;
}

/* .vdp-datepicker__calendar {
  position: fixed;
  top: auto;
} */
.form-z .vdp-datepicker {
  position: initial !important;
}

.time-horizon-cs {
  padding: 0px 4px 0px 4px !important;
}

.v-select {
  width: 100%;
  margin-left: 10px;
}

.txt-fmt {
  font-size: small;
}

.dropdown-menu {
  font-size: small;
}

.new-tbl-cs {
  appearance: none;
  border: 1px solid rgba(60, 60, 60, .26);
  border-radius: 4px;
  white-space: normal;
  height: 1.5rem;
  width: 100%;
  height: 1.9rem;
  padding: 0 6px;
}

.new-tbl-aaa-cs {
  appearance: none;
  border: 1px solid rgba(60, 60, 60, .26);
  border-radius: 4px;
  white-space: normal;
  height: 1.5rem;
  width: 100%;
  height: 1.9rem;
  padding: 0 6px;
  margin: 3px 0 3px;
}

.user-profiling label {
  margin-bottom: 0;
  font-weight: normal;
}

.v-select li a {
  text-wrap: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/acl/user-profiling.vue